// extracted by mini-css-extract-plugin
export default {"container":"Order_container__ky5zZ","tab":"Order_tab__nkaZj","orderStatus":"Order_orderStatus__O6yKG","logisticsInfoContainer":"Order_logisticsInfoContainer__gqo+e"};